module.exports = __webpack_public_path__ + "static/img/store-logos-google.4e36f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store-logos-google.png
// module id = mWNp
// module chunks = 0